import { render, staticRenderFns } from "./ProjectsList.vue?vue&type=template&id=657dca4c&scoped=true"
import script from "./ProjectsList.vue?vue&type=script&lang=js"
export * from "./ProjectsList.vue?vue&type=script&lang=js"
import style0 from "./ProjectsList.vue?vue&type=style&index=0&id=657dca4c&prod&lang=scss&scoped=true"
import style1 from "./ProjectsList.vue?vue&type=style&index=1&id=657dca4c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657dca4c",
  null
  
)

export default component.exports